export default function typewriter() {
    const quote = document.getElementById('typewriter-quote');
    if (!quote) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                quote.classList.add('start-typing');
                observer.unobserve(quote);
            }
        });
    }, { threshold: 0.5 });

    observer.observe(quote);
}
